module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-singfirst.jpg?v=3029adc2";